import React, { Suspense, useState } from 'react';
import { useStyletron } from 'baseui'
import { Button, KIND } from 'baseui/button';
import { SIZE, SHAPE } from 'baseui/button-group';
import { IScheduler, ViewModes } from '../types'
import * as config from '../config'
import { ISchedulerEvent, toEvent } from '../weeklyScheduleConverter';
import { VscAdd } from 'react-icons/vsc';
import { AddEntryDialog, IAddEventState } from '../AddEntryDialog';
import { FormattedMessage } from 'react-intl';
import ListViewItemContent from '../components/WeekListViewItemContent';
import DefaultItemContent from '../components/DefaultItemContent';
import { toUTCDateNoSeconds } from '../../../../utils/timeUtils';
import { TValueOption } from '../ValueCell/ValueCellSelector';


const SchedulerPanel = React.lazy(() => import('../SchedulerPanel'));

const EditableScheduler = (props: { view: any, app: IScheduler, events: ISchedulerEvent[], dataType: any, onEventsChanged: (events: ISchedulerEvent[]) => void }) => {
    const [css, theme] = useStyletron();
    const events = props.events;
    const [locTime, setLocTime] = useState(toUTCDateNoSeconds(new Date()));

    const valueOptions: TValueOption[] | undefined = (props.app.stateTextList && props.app.stateTextList !== '') ?
        JSON.parse(props.app.stateTextList).map((val, index) => ({ label: val, value: index + 1 }))
        : undefined;
    return (
        <>
            <div className={css({
                position: 'relative',
            })}>
                <Suspense fallback={"loading ..."}>
                    <SchedulerPanel onEventChanged={handleEventChanged} events={events} renderEventContent={renderEventContent} locTime={locTime} businessHours={config.businessHours} view={props.view}></SchedulerPanel>
                </Suspense>
                <div className={css({
                    position: 'absolute',
                    bottom: '-20px',
                    right: '-20px',
                    zIndex: 9999,
                })}>

                    <AddEvent valueOptions={valueOptions} showDays={props.view !== 'timeGridDay'} dataType={props.dataType} onAdd={onAddEvent}></AddEvent>
                </div>
            </div>
            <Button onClick={onClearAll} kind='tertiary' size='compact'><FormattedMessage id="Calendar.ClearAll" defaultMessage="Clear all" /></Button>
        </>
    );

    function onClearAll() {
        props.onEventsChanged([]);
    }
    function handleEventChanged(args: any) { // bind with an arrow function
        const event: any = args.event;
        const id = event.id;
        const index = events.findIndex((ev) => ev.id === id);
        const newval = () => {
            const tmp = [...props.events];
            const oldelm = tmp[index];
            const newElm: ISchedulerEvent = {
                id: oldelm.id,
                title: oldelm.title,
                startTime: event.start.toTimeString(),
                endTime: event.end.toTimeString(),
                backgroundColor: oldelm.backgroundColor,
                color: oldelm.color,
                daysOfWeek: oldelm.daysOfWeek,
                weekday: oldelm.weekday
            };
            tmp[index] = newElm;
            return tmp;
        };

        props.onEventsChanged(newval());
    }

    function onAddEvent(event: IAddEventState) {
        const newval = () => {
            const tmp = [...props.events];
            if (props.view !== 'timeGridDay') {
                for (let i = 0; i < 7; i++) {
                    if (event.days[i])
                        tmp.push(toEvent(i + 1, event.timeFrom, event.timeTo, event.value, 9999, theme))
                }
            }
            else {
                tmp.push(toEvent(new Date().getDay(), event.timeFrom, event.timeTo, event.value, 9999, theme))
            }
            return tmp;
        };
        props.onEventsChanged(newval());
    }

    function onDeleteEvent(event: any) {
        const id = event.id;
        const index = events.findIndex((ev) => ev.id === id);

        const newval = () => {
            const tmp = [...props.events];
            tmp.splice(index, 1);
            return tmp;
        };
        props.onEventsChanged(newval());
    }

    function handleValueChanged(newValue: any, eventId: string) {
        const newval = () => {
            const id = eventId;
            const index = props.events.findIndex((ev) => ev.id === id);
            const tmp = [...props.events];
            const oldelm = tmp[index];

            const newElm: ISchedulerEvent =
            {
                id: oldelm.id,
                title: newValue.value,
                startTime: newValue.timeFrom.toTimeString(),
                endTime: newValue.timeTo.toTimeString(),
                backgroundColor: oldelm.backgroundColor,
                color: oldelm.color,
                daysOfWeek: oldelm.daysOfWeek,
                weekday: oldelm.weekday
            };
            tmp[index] = newElm;
            return tmp;
        };
        props.onEventsChanged(newval());
    }

    function renderEventContent(eventInfo: any) {
        
        if (props.view === ViewModes.listWeek)
            return (<ListViewItemContent app={props.app} eventInfo={eventInfo} onDeleteEvent={onDeleteEvent} onValueChanged={handleValueChanged}></ListViewItemContent>)
        return (<DefaultItemContent app={props.app} eventInfo={eventInfo} onDeleteEvent={onDeleteEvent} onValueChanged={handleValueChanged}></DefaultItemContent>)
    };
}

export default EditableScheduler;



function AddEvent(props: { dataType: string, onAdd, showDays: boolean, valueOptions: TValueOption[] | undefined }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button onClick={() => setIsOpen(true)} kind={KIND.primary} size={SIZE.default} shape={SHAPE.round} overrides={{
                BaseButton: {
                    style: ({ $theme }) => ({
                        boxShadow: $theme.lighting.shadow400,
                    })
                }
            }}
            >
                <VscAdd></VscAdd>
            </Button>
            <AddEntryDialog valueOptions={props.valueOptions} showDays={props.showDays} dataType={props.dataType} onAdd={props.onAdd} isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    )
};


